import React from 'react'
import { message } from 'antd'
import PageLayout from '@layouts/PageLayout'
import { useHistory } from 'react-router-dom'
import FormComponent from './Form'
import { client } from '@utils/client'

const Create = () => {
  const history = useHistory()
  const handleSubmit = async (data) => {
    try {
      await client.post('/blog', data)
      message.success('สำเร็จ')
      history.push('/blogs')
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }

  return (
    <PageLayout title="เพิ่มบทความใหม่" extra={[]}>
      <FormComponent handleSubmit={handleSubmit} />
    </PageLayout>
  )
}

export default Create
